//Navigation view for smaller screens (x<768)

import React from 'react';
import {Glyphicon} from 'react-bootstrap';
import onClickOutside from 'react-onclickoutside';

class AccordionNavigation extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      show: false,
      noAnimation: true,
    }
  }

  handleClickOutside(){
    this.state.show && this.setState({show: false});
  }

  toggleMenu(){
    this.setState({
      show: !this.state.show,
      noAnimation: false,
    });
  }

  selectOption(tab){
    this.toggleMenu();
    tab.onClick();
  }
  //Navigation component for when the page is xs
  //TODO: https://stackoverflow.com/questions/35687353/react-bootstrap-link-item-in-a-navitem
  //TODO: merge with TabNav
  render() {
    const extraClass = this.state.show ? "" : (this.state.noAnimation ? " display-none" : " hide-menu");
    return (
      <div className="AccordionNavigation">
        <Glyphicon className="menu-icon" glyph="menu-hamburger" onClick={this.toggleMenu.bind(this)} />
        <ul className={"menu-list" + extraClass}>
        {this.props.tabData.map(tab =>
          <li className="menu-option" onClick={() => this.selectOption(tab)} key={tab.id}>{tab.name}</li>
        )}
        </ul>
      </div>
    );
  }
}

export default onClickOutside(AccordionNavigation);


// WEBPACK FOOTER //
// ./src/components/AppLayout/AccordionNavigation.js